module.exports = "images/okoo.2f9d2e84.png";